import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import common from './modules/common'
import demo from './modules/demo'
import getters from './getters'

Vue.use(Vuex)

const plugins = [createPersistedState()]

export default new Vuex.Store({
  plugins,
  modules: {
    common,
    demo
  },
  // strict: process.env.NODE_ENV !== 'production',
  getters
})
